import type { FetchModelResponse } from '@cian/http-api';

import type { IV2CreateConsultingResponse } from '../../../repositories/newbuilding-flat-view-order/entities/consulting_request/V2CreateConsultingResponse';
import type { TCreateConsultingRequestResponse } from '../../../repositories/newbuilding-flat-view-order/v2/create-consulting-request';
import { ResponseError, mapResponseErrors } from '../../../utils/errors';

export function assertResponseError(
  response: TCreateConsultingRequestResponse,
): asserts response is FetchModelResponse<200, 'json', IV2CreateConsultingResponse> {
  if (response.statusCode === 200) {
    return;
  }

  const { message, errors } = response.response;

  throw new ResponseError({
    domain: 'shared/services/consultingRequest/createConsultingRequest#assertResponseError()',
    message: message as string,
    details: mapResponseErrors(errors as unknown[]),
  });
}
